import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Typography from '../../../common/Typography';
import useStyles from './styles';

const TOS = 'abae4562-b0ba-42d2-9277-a4e136c53f05';
const PRIVACY_POLICY = '8a58ba8a-2631-4558-8105-9cb526d9305f';
const COOKIE_POLICY = '031cee16-f717-40a3-957b-e90d54037c72';
const RETURN = '7d297e7e-16d9-4c66-8e32-a6c83f270c1c';
const DISCLAIMER = 'db997f46-428c-43e7-9ce9-0247d511ad1d';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AppFooter = () => {
  const classes = useStyles();
  const history = useHistory();
  const currentYear = new Date().getFullYear();
  const [openTerms, setOpenTerms] = useState(false);

  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://app.termly.io/embed-policy.min.js"]');

    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    script.onload = () => {
      if (window.iFrameResize) {
        window.iFrameResize({ warningTimeout: 0 }, '[name="termly-embed"]');
      }
    };

    document.body.appendChild(script);
  }, []);

  const handleTermsClick = () => {
    setOpenTerms(true);
    forceUpdate();
  };

  const handleTermsClose = () => {
    setOpenTerms(false);
  };

  const handlePrivacyClick = () => {
    window.open('https://usfcr.com/company/privacy-policy/', '_blank', 'noopener,noreferrer');
  };

  const handleReleasesClick = () => {
    history.push('/releases');
  };

  return (
    <>
      <footer className={classes.footer}>
        <div className={classes.content}>
          <Typography component="span" variant="body2" className={classes.text}>
            © {currentYear} USFCR
          </Typography>

          <span className={classes.separator}>·</span>

          <Typography component="span" variant="body2">
            <span className={classes.link} onClick={handleTermsClick}>
              Terms and Conditions
            </span>
          </Typography>

          <span className={classes.separator}>·</span>

          <Typography component="span" variant="body2">
            <span className={classes.link} onClick={handlePrivacyClick}>
              Privacy Policy
            </span>
          </Typography>

          <span className={classes.separator}>·</span>

          <Typography component="span" variant="body2">
            <span className={classes.link} onClick={handleReleasesClick}>
              Releases
            </span>
          </Typography>
        </div>
      </footer>

      <Dialog fullScreen open={openTerms} onClose={handleTermsClose} TransitionComponent={Transition} keepMounted>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleTermsClose} aria-label="close">
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" className={classes.title}>
              Terms & conditions
            </Typography>
          </Toolbar>
        </AppBar>

        <div>
          <div name="termly-embed" data-id={TOS} data-type="iframe"></div>
          <div name="termly-embed" data-id={PRIVACY_POLICY} data-type="iframe"></div>
          <div name="termly-embed" data-id={COOKIE_POLICY} data-type="iframe"></div>
          <div name="termly-embed" data-id={RETURN} data-type="iframe"></div>
          <div name="termly-embed" data-id={DISCLAIMER} data-type="iframe"></div>
        </div>
      </Dialog>
    </>
  );
};

export default AppFooter;
